import Vue from 'vue'
import Component from 'vue-class-component'
import { FooterMenuEvent, ScreenId } from '@/utilities'
import { footerMenuEventBus } from '@/main'

@Component
export class FooterMenuMixin extends Vue {
  private screenId: ScreenId = ScreenId.MTP_0000

  protected notifyFooterMenuAboutCurrentScreen(screenId: ScreenId): void {
    this.screenId = screenId
    footerMenuEventBus.$emit(FooterMenuEvent.ChangeTab, this.screenId)
  }
}
